import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function formatErr(e) {
  const detail = e?.response?.data?.detail ?? e?.detail ?? e;
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (detail?.msg) return detail.msg;
  if (e?.message) return e.message;
  return String(detail);
}

export const brl = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const shortUrl = (code) => `${API}/r/${code}`;
export const fmtDate = (d) => (d ? new Date(d.length === 10 ? d + "T12:00:00" : d).toLocaleDateString("pt-BR") : "-");
export const copy = async (text) => navigator.clipboard.writeText(text);

export const CHANNELS = [
  { id: "instagram", label: "Instagram", color: "#E1306C" },
  { id: "facebook", label: "Facebook", color: "#1877F2" },
  { id: "tiktok", label: "TikTok", color: "#00F2FE" },
  { id: "shorts", label: "Shorts", color: "#FF0033" },
  { id: "whatsapp", label: "WhatsApp", color: "#25D366" },
];
export const channelLabel = (id) => CHANNELS.find((c) => c.id === id)?.label || id;
export const NICHES = ["Tecnologia", "Casa", "Moda", "Beleza", "Infantil", "Pets", "Esporte", "Cozinha", "Outros"];
